module.exports = __webpack_public_path__ + "img/HappyPhoto39.cb7437d4.jpeg";